import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';

const TEXTS = {
  'pt-br': {
    msg: 'Usamos cookies para lembrar o seu idioma, proteger a sua experiência e melhorar a navegação, conforme a LGPD.',
    accept: 'Aceitar',
    reject: 'Recusar',
    more: 'Política de Privacidade',
  },
  es: {
    msg: 'Usamos cookies para recordar su idioma y país, y para mejorar la navegación, conforme a las leyes de protección de datos.',
    accept: 'Aceptar',
    reject: 'Rechazar',
    more: 'Aviso de Privacidad',
  },
  en: {
    msg: 'We use cookies to remember your language and improve your browsing experience.',
    accept: 'Accept',
    reject: 'Reject',
    more: 'Privacy Notice',
  },
};

export default function CookieBanner() {
  const { lang, route } = useLang();
  const [choice, setChoice] = useState(() => localStorage.getItem('rt_consent'));
  if (choice) return null;
  const t = TEXTS[lang] || TEXTS['pt-br'];

  const decide = (value) => {
    localStorage.setItem('rt_consent', value);
    setChoice(value);
  };

  return (
    <div data-testid="cookie-banner" className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-brand-deep/95 text-white backdrop-blur-xl">
      <div className="container-x flex flex-col items-start gap-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="flex items-center gap-3 text-[13px] leading-relaxed text-white/75">
          <Cookie className="h-5 w-5 shrink-0 text-brand-cyan" />
          {t.msg}
          <Link to={route('privacy')} data-testid="cookie-privacy-link" className="shrink-0 font-semibold text-brand-cyan underline-offset-2 hover:underline">
            {t.more}
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <button data-testid="cookie-reject-btn" onClick={() => decide('rejected')} className="rounded-full border border-white/25 px-4 py-2 text-[13px] font-semibold text-white/80 transition hover:border-white/60">
            {t.reject}
          </button>
          <button data-testid="cookie-accept-btn" onClick={() => decide('accepted')} className="rounded-full bg-brand-blue px-5 py-2 text-[13px] font-semibold text-white transition hover:bg-brand-bluedark">
            {t.accept}
          </button>
        </div>
      </div>
    </div>
  );
}